module.exports = __webpack_public_path__ + "static/phura-4d05491298ebd7708ea08cdbdbcb9e9b.jpg";